import { c as _c } from "react/compiler-runtime";
import { Typography } from "@mui/material";
import React from "react";
type StructureDisplayLabelProps = {
  label: string;
};

/** Small caption above a runtime structure when we inferred a variable name from user code. */
export const StructureDisplayLabel: React.FC<StructureDisplayLabelProps> = t0 => {
  const $ = _c(3);
  const {
    label
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      fontFamily: "monospace",
      lineHeight: 1.2,
      mb: 0.25
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label) {
    t2 = <Typography component="div" variant="caption" color="text.secondary" sx={t1}>{label}</Typography>;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};